import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

// Inbox search params: filters travel in the URL so a saved view can persist
// them. Status uses the LeadStatus enum, owner_user_id is a free-form id, q is
// a debounced text search, and segment_id selects a saved view.
export const Route = createFileRoute("/app/inbox/")({
  validateSearch: z.object({
    status: z.string().optional(),
    owner_user_id: z.string().optional(),
    q: z.string().optional(),
    segment_id: z.string().optional(),
  }),
});
